<div class="card-content calendar-container">
    <div class="card-body">
        <ngb-datepicker
            #dp1
            [ngModelOptions]="{ standalone: true }"
            ngModel
            (ngModelChange)="onDateChange($event)"
            [displayMonths]="2"
            [dayTemplate]="t"
        >
        </ngb-datepicker>

        <ng-template #t let-date="date" let-focused="focused">
                            <span
                                    class="custom-day"
                                    [class.focused]="focused"
                                    [class.range]="isFrom(date) || isTo(date) || isInside(date) || isHovered(date)"
                                    [class.faded]="isHovered(date) || isInside(date)"
                                    (mouseenter)="hoveredDate = date"
                                    (mouseleave)="hoveredDate = null"
                            >
                                {{ date.day }}
                            </span>
        </ng-template>
    </div>
</div>
